import { Injectable, inject } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import * as actions from './broker-search.actions';
import { getIndex } from '@state/utils/helper';
import { IndexType } from '@fnModels/algolia/algolia';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';
import { AlgoliaMortgageBroker } from '@fnModels/algolia/broker';
import { AlgoliaHit } from '@state/utils/models';
import { LeapApiService } from 'src/app/shared/api-repos/leap/leap-api.service';

export type BrokerSearchStateModel = AlgoliaBaseState<unknown>;

@State<BrokerSearchStateModel>({
	name: 'brokerSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class BrokerSearchState extends AlgoliaSearchState<BrokerSearchStateModel> {
	private leapApiService = inject(LeapApiService);
	protected indexName = getIndex(IndexType.BROKERS);

	@Selector([BrokerSearchState])
	static getList(state: BrokerSearchStateModel) {
		return state?.items;
	}

	@Selector([BrokerSearchState])
	static getSearching(state: BrokerSearchStateModel) {
		return state?.searching;
	}

	@Action(actions.Reset)
	async reset({ patchState }: StateContext<BrokerSearchStateModel>) {
		patchState({ searching: false, error: null, items: [] });
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<BrokerSearchStateModel>,
		{ payload }: actions.Search,
	) {
		const facetFilters = [];
		if (payload?.brokerageId) {
			facetFilters.push(`brokerageId:${payload.brokerageId}`);
		}

		// if (this.store.selectSnapshot(SelectedMatter.isLeapMatter)) {
		// 	await this.brokerSearchLeap(
		// 		ctx,
		// 		`${payload.searchValue}&cardId=${payload.cardId}`,
		// 	);
		// } else {
		await this.algoliaSearchHandler(ctx, payload.searchValue, {
			userToken: this.user.id,
			facetFilters,
		});
		//}
	}

	async brokerSearchLeap(
		{ patchState }: StateContext<BrokerSearchStateModel>,
		searchTerm: string,
	) {
		patchState({ searching: true, searchTerm, success: false, error: null });
		if (!searchTerm) return;
		const results = await this.leapApiService
			.searchBrokers(searchTerm)
			.toPromise();

		patchState({
			success: true,
			searching: false,
			items: results as AlgoliaHit<AlgoliaMortgageBroker>[],
		});
	}
}
